export let API_BASE_URL = ""

if (process.env.NODE_ENV === "development") {
  API_BASE_URL = "http://localhost:4000"
}
